import { WrongPasswordError } from "@core/errors/Errors";
import { i18n } from "@/i18n";
import { showAlert } from "@core/ui/alert/alert";

export async function tryWithPasswordHeader<R>(
  password: string | undefined,
  callback: (headers: Record<string, string>) => R,
  setPassword = (_s: string) => {}
) {
  const headers: Record<string, string> = {};
  do {
    if (password) {
      // make sure to transform utf-8 characters.
      headers["simcision-password"] = `Password ${btoa(
        unescape(encodeURIComponent(password))
      )}`;
      setPassword(password);
    }

    try {
      return await callback(headers);
    } catch (_error) {
      const error = _error as { code?: string };
      if (error?.code === "wrong_password") {
        const { nextPassword } = await showAlert<{ nextPassword: string }>({
          title: i18n.t("headings.inputPassword"),
          content: [
            {
              type: "text",
              text: i18n.t("messages.modelHasPassword")
            },
            {
              type: "password",
              name: "nextPassword",
              label: i18n.t("labels.password"),
              autofocus: true,
              user: "password-field",
              required: true,
              value: ""
            }
          ],
          denyText: i18n.t("labels.abort")
        });
        password = nextPassword;
        if (!nextPassword) {
          throw new WrongPasswordError();
        }
      } else {
        throw error;
      }
    }
    // eslint-disable-next-line no-constant-condition
  } while (true);
}
